// ─── §11 rule 37 — Per-entity write: fail-immediate ──────────────────────────
//
// Surfaced when a single-entity save fails (permission revoked, disk full,
// sync conflict, etc.). Offers the user two explicit paths:
//
//   Retry          → parent calls its save path again. `dirty` stays true
//                    so the unsaved-changes state is preserved across attempts.
//   Discard changes → parent reverts the form to its last-saved snapshot
//                    (savedRecord) and clears dirty. In-memory state is lost
//                    only by this explicit user choice, never implicitly.
//
// The dialog is a focused 2-button variant of ConfirmDialog — no Cancel,
// because rule 37 requires the user to pick one. Sits next to ConfirmDialog
// in shared/ because both are save-lifecycle modals.

import { BTN_PRIMARY, BTN_DESTRUCTIVE_FILLED, BORDER_DEFAULT, TEXT_HEADING, BG_SURFACE, FONT_SECTION_TITLE, FONT_BODY, FONT_BUTTON } from '../../theme';

const T = {
  es: {
    title:   'Error al guardar',
    message: 'No se pudo guardar el registro. Puedes reintentar la operación o descartar los cambios sin guardar.',
    retry:   'Reintentar',
    discard: 'Descartar cambios',
  },
  en: {
    title:   'Save failed',
    message: 'The record could not be saved. You can retry the operation or discard your unsaved changes.',
    retry:   'Retry',
    discard: 'Discard changes',
  },
};

export default function SaveErrorDialog({ open, lang, onRetry, onDiscard }) {
  if (!open) return null;
  const t = T[lang] || T.en;
  return (
    <div
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(15, 34, 53, 0.45)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: BG_SURFACE,
          border: `1px solid ${BORDER_DEFAULT}`,
          borderRadius: 10,
          padding: '1.75rem 2rem',
          maxWidth: 420,
          width: '90%',
        }}
      >
        <h3 style={{
          ...FONT_SECTION_TITLE,
          fontWeight: 700,
          color: TEXT_HEADING, margin: '0 0 0.75rem',
        }}>
          {t.title}
        </h3>
        <p style={{
          ...FONT_BODY,
          color: TEXT_HEADING,
          margin: '0 0 1.5rem',
          lineHeight: 1.55,
        }}>
          {t.message}
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
          <button
            type="button"
            onClick={onRetry}
            style={{
              ...BTN_PRIMARY,
              ...FONT_BUTTON,
              fontWeight: 700,
              border: 'none',
              borderRadius: 8,
              padding: '0.5rem 1.1rem',
              cursor: 'pointer',
            }}
          >
            {t.retry}
          </button>
          <button
            type="button"
            onClick={onDiscard}
            style={{
              ...BTN_DESTRUCTIVE_FILLED,
              ...FONT_BUTTON,
              fontWeight: 700,
              border: 'none',
              borderRadius: 8,
              padding: '0.5rem 1.1rem',
              cursor: 'pointer',
            }}
          >
            {t.discard}
          </button>
        </div>
      </div>
    </div>
  );
}
